import apiClient from "services/apiClient";

async function addSpecie(data: any) {
  const url = `/admin/species`;
  const res = await apiClient.post(url, data);
  return res.data;
}

export default addSpecie;
